export default {"src":"/_next/static/media/beam.b94a0df4.svg","height":48,"width":160,"blurWidth":0,"blurHeight":0};